import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/message/message.styles.ts
var message_styles_default = r` ${component_styles_default} :host { font-family: var(--sl-font-sans); } .message { padding: var(--sl-spacing-x-small) var(--sl-spacing-medium); } .message .message__header { margin-left: var(--sl-spacing-small); margin-right: var(--sl-spacing-small); margin-bottom: var(--sl-spacing-2x-small); display: flex; } .message .message__header fadv-typography { display: block; width: 50%; } .message .message__header fadv-typography.message__description { text-align: right; } .message .message__content { display: block; background: var(--sl-color-gray-300); border-radius: var(--sl-border-radius-large); padding: var(--sl-spacing-small); } @media screen and (max-width: 320px) { .message .message__header { display: flex; flex-direction: column; align-items: flex-start; } .message .message__header fadv-typography.message__description { text-align: left; } .message .message__header fadv-typography { width: 100%; } } `;

export {
  message_styles_default
};
